import { createAsyncThunk } from '@reduxjs/toolkit';
import { AmplifyUIActions } from '../../../actions/action-types';
import { getConfigurationsForSectionV2 } from '../../configuration-utils';

const getCoderConfig = createAsyncThunk<
  CMxAPI.ConfigurationSection[],
  CMxCommonApp.SectionAPIArguments,
  { rejectValue: CMxCommonApp.CMxError }
>(AmplifyUIActions.GET_CODER_CONFIG, async args => {
  return getConfigurationsForSectionV2(args);
});

export { getCoderConfig };
